export default "__VITE_ASSET__BFaHbiaZ__"